module.exports = __webpack_public_path__ + "img/HR.dd5431b7.svg";